// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectDrugGroupsInStore,
  selectDrugGroupsPageLoading,
  selectDrugGroupsShowInitWaitingMessage,
} from '../_selectors/drug-group.selectors';

export class DrugGroupsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectDrugGroupsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectDrugGroupsShowInitWaitingMessage));

    this.store.pipe(select(selectDrugGroupsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
